/* ThrivingMoms — Quotes carousel autoplay patch
   Waits for slick to finish initializing before
   enabling autoplay. Uses MutationObserver so timing
   doesn't matter — fires as soon as slick is ready.
*/
(function () {
  var SLIDER_ID = 'Quotes-quotes_cnRBfd';
  var AUTOPLAY_SPEED = 3000;

  function enableAutoplay() {
    var el = document.getElementById(SLIDER_ID);
    if (!el) return;

    if (typeof jQuery === 'undefined') return;
    var $el = jQuery(el);

    if ($el.hasClass('slick-initialized')) {
      $el.slick('slickSetOption', 'autoplay', true, false);
      $el.slick('slickSetOption', 'autoplaySpeed', AUTOPLAY_SPEED, false);
      $el.slick('slickPlay');
      return;
    }

    /* Slick not ready yet — watch for the class being added */
    var observer = new MutationObserver(function (mutations, obs) {
      var el2 = document.getElementById(SLIDER_ID);
      if (!el2) return;
      if (el2.classList.contains('slick-initialized')) {
        obs.disconnect();
        var $el2 = jQuery(el2);
        $el2.slick('slickSetOption', 'autoplay', true, false);
        $el2.slick('slickSetOption', 'autoplaySpeed', AUTOPLAY_SPEED, false);
        $el2.slick('slickPlay');
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableAutoplay);
  } else {
    enableAutoplay();
  }
})();
